<script>
// import { BIcon } from 'bootstrap-vue'
import KnobControl from 'vue-knob-control'

export default {
  components: { KnobControl },
  props: {
    applications: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    type: {
      required: true,
    },
  },
  data() {
    return {
      formListToggle: false,
      activeApplication: this.active,
      formStatus: 0,
    }
  },
  watch: {
    status(newVal, oldVal) {
      if (newVal !== oldVal) this.formStatus = this.status
    },
    active(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.activeApplication = this.active
        //   console.log(this.active)
      }
    },
  },
  beforeMount() {
    this.formStatus = this.status
  },
  beforeDestroy() {
    var doc = this.$refs.applinkroute
    if (doc !== undefined) doc.innerHTML = ''
  },
  mounted() {
    // console.log(this.applications)
    this.$root.$on('knobFormTotal', (data) => {
      if (data) {
        var x = this.applications
        var count = 0
        for (var i = 0; i < x.length; i++) {
          if (this.applications[i].percentage === 1) count++
        }
        var countPercentage = Math.round((count / x.length) * 100)
        if (status !== countPercentage) this.formStatus = countPercentage
      }
    })
  },
  methods: {
    setActiveApplication(name) {
      //   this.activeApplication = name
      //  console.log(this.activeApplication)

      this.$emit('click', { name: name, show: true })
    },
  },
}
</script>
<template>
  <ul ref="applinkroute" :class="$style.applicationsMenu">
    <li :class="$style.applicationsMenuList">
      <a
        id="menuLinks"
        :class="[$style.applicationsMenuLink, $style.title]"
        class="menuLink"
      >
        <!-- <BIcon :class="$style.completed" class="mr5" icon="file-text"></BIcon> -->
        Application Form
        <span :class="$style.percentageKnob"
          ><KnobControl
            v-model="formStatus"
            :stroke-width="10"
            primary-color="#37d381"
            secondary-color="#d7d7d7"
            :size="30"
          ></KnobControl
        ></span>
      </a>
    </li>
    <li
      v-for="application in applications"
      :key="application.name + activeApplication + application.percentage"
      :ref="application.name"
      :class="$style.applicationsMenuList"
    >
      <a
        id="menuLinks"
        :class="
          application.percentage > 0
            ? activeApplication == application.name
              ? [$style.applicationsMenuLink, $style.completed, $style.active]
              : [$style.applicationsMenuLink, $style.completed]
            : activeApplication == application.name
            ? [$style.applicationsMenuLink, $style.pending, $style.active]
            : [$style.applicationsMenuLink, $style.pending]
        "
        class="menuLink"
        @click="setActiveApplication(application.name)"
        >{{ application.name }}
        <span :class="$style.status">
          <BIcon
            v-if="application.percentage > 0"
            :class="$style.completed"
            icon="check-circle-fill"
          ></BIcon>
          <BIcon
            v-else
            :class="$style.pending"
            icon="exclamation-circle-fill"
          ></BIcon>
        </span>
      </a>
    </li>
  </ul>
</template>

<style lang="scss" module>
@import '@design';

.percentageKnob {
  display: block;
  float: right;
  margin-left: 5px;
  pointer-events: none !important;
  text {
    font-size: 30px !important;
  }
}

// Profile Menu
.applicationsMenu {
  .applicationsMenuList {
    position: relative;
    display: block;
    width: 100%;
    border-bottom: 2px solid #f8f9f9;
    transition: all ease-in-out 0.3s;

    &:last-child {
      border-bottom: 0;
    }
  }

  .applicationsMenuLink {
    position: relative;
    display: block;
    padding: 20px 35px 20px 15px;
    font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 15px;
    // color: $color-main-title !important;
    color: #808d99;
    text-decoration: none !important;
    transition: all ease-in-out 0.3s;

    .status {
      position: absolute;
      top: 25px;
      right: 15px;
    }

    &:hover,
    &.active {
      color: #212529;
      background: #fafafa;
      transition: all ease-in-out 0.3s;
    }

    &.completed {
      .completed {
        display: block;
        color: #60e8bb !important;
      }
      .pending {
        display: none;
      }
    }

    &.pending {
      .completed {
        display: none;
      }
      .pending {
        display: block;
        color: #fdc360 !important;
      }
    }

    &.title {
      padding: 20px 15px;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 17px;
      color: #818284;

      &:hover {
        background: #fff;
      }
    }
  }
}
// Profile Menu

@media (max-width: 767px) {
  .applicationsMenuLink {
    &.title {
      font-size: 16px;
    }
  }
}
</style>
